<template>
    <div class="w-100 p-1 px-2 my-1" :class="{ widget: enteringData }">
        <div class="w-100 d-flex justify-content-end">
            <p @click="addData()" v-if="!enteringData" class="text-primary cursor-pointer mb-0">
                <em>Rename Axes</em><i class="ml-2 fa fa-times-circle-o rot-45"></i>
            </p>
        </div>
        <div class="w-100" v-if="enteringData">
            <div class="d-flex justify-content-between align-items-center w-100">
                <p class="text-uppercase font-weight-bold py-1 mb-0">Rename Axes</p>
                <i
                    v-if="!enteringData"
                    @click="enteringData = true"
                    class="fa fa-edit cursor-pointer mx-1 text-primary ml-auto"
                ></i>
                <i
                    @click="closeInput"
                    class="fa fa-times-circle-o cursor-pointer mx-1 text-primary"
                ></i>
            </div>
            <hr
                style="width:100%;margin:auto;color:#c3c3c3;background: #c3c3c3; height: 1px; margin-bottom: 0.5rem;"
            />
            <div v-if="enteringData" class="d-flex justify-content-between">
                <input
                    v-model="xAxisLabel"
                    class="form-control form-control-sm"
                    id="x"
                    placeholder="Horizontal axis"
                />
                <input
                    v-model="y1AxisLabel"
                    class="form-control form-control-sm"
                    id="y1"
                    placeholder="Vertical axis - main"
                />
                <input
                    v-model="y2AxisLabel"
                    class="form-control form-control-sm"
                    id="y2"
                    placeholder="Vertical axis - secondary"
                />
                <div
                    @click="updateAxesNames()"
                    class="d-flex flex-column justify-content-center align-items-center ml-2 cursor-pointer"
                >
                    <i
                        :class="loading ? 'fa-spin fa-circle-o-notch' : 'fa-save'"
                        class="fa text-primary"
                    ></i>
                    <small><em class="text-primary text-nowrap">Save</em></small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GoalsRenameAxes",
    props: ["goal"],
    data() {
        return {
            enteringData: false,
            loading: false,
            xAxisLabel: null,
            y1AxisLabel: null,
            y2AxisLabel: null,
            chartMetaData: null,
        };
    },
    created() {
        this.getAxesNames();
        this.$bus.$on("chart-metadata", payload => {
            this.chartMetaData = payload;
            if (!this.xAxisLabel) this.xAxisLabel = this.chartMetaData.x_axis_label;
            if (!this.y1AxisLabel) this.y1AxisLabel = this.chartMetaData.y1_axis_label;
            if (!this.y2AxisLabel) this.y2AxisLabel = this.chartMetaData.y2_axis_label;
        });
    },
    watch: {
        goal() {
            this.getAxesNames();
        },
    },
    methods: {
        getAxesNames() {
            this.xAxisLabel = this.goal.chart_x_axis_label;
            this.y1AxisLabel = this.goal.chart_y1_axis_label;
            this.y2AxisLabel = this.goal.chart_y2_axis_label;
        },
        updateAxesNames() {
            this.loading = true;
            let payload = {
                chart_x_axis_label: this.xAxisLabel,
                chart_y1_axis_label: this.y1AxisLabel,
                chart_y2_axis_label: this.y2AxisLabel,
            };
            axios
                .patch(`/api/patients/${this.goal.patient.id}/goals/${this.goal.id}`, payload)
                .then(r => {
                    this.loading = false;
                    this.enteringData = false;
                    this.$bus.$emit("redraw-chart", payload);
                });
        },
        addData() {
            this.enteringData = true;
        },
        closeInput() {
            this.enteringData = false;
        },
    },
};
</script>

<style scoped lang="scss">
.widget {
    background-color: #fff;
}
</style>
